import { Box, H1, Icon, Text } from '@betterment/samba-react';

import { Header } from './Header';

import { WithLayout } from '../../RetailApp/components/WithLayout';

export const Error: React.FC = () => {
  return (
    <WithLayout parts={{ sidebar: false }}>
      <Header />
      <Box
        css={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 'space.400',
          paddingTop: 'space.800',
        }}
      >
        <Icon name="QuestionMarkCircle" size="large" color="icon.warning" css={{ marginBottom: 'space.400' }} />
        <H1>We couldn't find your invitation</H1>
        <Text>Contact your advisor for help.</Text>
      </Box>
    </WithLayout>
  );
};
